import * as React from "react";
import { Link, styled } from "@mui/material";
import { useTranslateByGender } from "fe-common/locale/useTranslateByGender";
import { navigateWithLocale } from "../../utils";
import { useNavigate } from "react-router-dom";
import { Container } from "./Container";
import { GeneralQuestion } from "./GeneralQuestion";
import { InsightsDisplay } from "../InsightsDisplay";
import { PatientSummary } from "../PatientSummary";
import { SessionInsights, SessionType } from "../../context/sessionStore";

//region [[ Styles ]]
const NewSessionInputView = styled("div")({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  gap: 14,
});
const HeaderView = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  alignSelf: "normal",
  gap: 8,
  "& h3": {
    color: theme.palette.text.primary,
    fontWeight: 600,
    fontSize: 16,
    margin: 0,
  },
  "& .session-type-link": {
    fontSize: 13,
  },
}));
const NewSessionDisclaimerView = styled("div")({
  fontSize: 13,
});

//endregion [[ Styles ]]

//region [[ Props ]]
interface NewSessionInputProps {
  sessionType: SessionType;
  withDisclaimer: boolean;
  withTopNav?: boolean;
  insights?: SessionInsights;
  rtlDisplay?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const NewSessionInput = ({
  sessionType,
  insights,
  withTopNav,
  withDisclaimer,
  rtlDisplay,
}: NewSessionInputProps) => {
  const { translate, locale } = useTranslateByGender();
  const navigate = useNavigate();
  return (
    <Container
      className={"summary-container"}
      style={
        insights ? { padding: "10px 2px", width: "100%" } : { width: "100%" }
      }
      maxWidth={"100%"}
      rtlDisplay={rtlDisplay}
    >
      <NewSessionInputView>
        {!insights && (
          <HeaderView>
            <h3>
              {translate(
                sessionType === SessionType.GENERAL
                  ? "DIALOGUES_ASK_GENERAL_QUESTION"
                  : "SUMMARY",
              )}
            </h3>

            <Link
              className={"session-type-link"}
              onClick={() => {
                navigate(
                  navigateWithLocale(
                    "../new/" +
                      (sessionType === SessionType.GENERAL
                        ? SessionType.PATIENT
                        : SessionType.GENERAL),
                    locale,
                    { replace: true },
                  ),
                );
              }}
            >
              {withTopNav &&
                translate(
                  sessionType === SessionType.GENERAL
                    ? "SUMMARY_INSERT"
                    : "DIALOGUES_ASK_GENERAL_QUESTION",
                )}
            </Link>
          </HeaderView>
        )}
        {sessionType === SessionType.GENERAL ? (
          <GeneralQuestion />
        ) : insights ? (
          <InsightsDisplay insights={insights} />
        ) : (
          <PatientSummary />
        )}
        {!insights && withDisclaimer && (
          <NewSessionDisclaimerView>
            * {translate("PII_WARNING")}
          </NewSessionDisclaimerView>
        )}
      </NewSessionInputView>
    </Container>
  );
};
